import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './ServicePage.css';

const MEPServices = () => {
  const features = [
    {
      icon: 'fas fa-blueprint',
      title: 'Detailed Technical Drawings',
      description: 'Comprehensive MEP drawings with precise specifications and industry standards compliance.',
      image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      icon: 'fas fa-calculator',
      title: 'Load Calculations',
      description: 'Accurate electrical, HVAC, and plumbing load calculations for optimal system performance.',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      icon: 'fas fa-project-diagram',
      title: 'System Integration',
      description: 'Seamless integration of mechanical, electrical, and plumbing systems for maximum efficiency.',
      image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      icon: 'fas fa-shield-alt',
      title: 'Code Compliance',
      description: 'Ensuring all designs meet local building codes and international safety standards.',
      image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    }
  ];

  const systems = [
    {
      title: 'Mechanical Systems',
      description: 'HVAC design, ventilation systems, and climate control solutions',
      icon: 'fas fa-fan',
      image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      title: 'Electrical Systems',
      description: 'Power distribution, lighting design, and electrical infrastructure',
      icon: 'fas fa-bolt',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      title: 'Plumbing Systems',
      description: 'Water supply, drainage, and specialized plumbing solutions',
      icon: 'fas fa-tint',
      image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    }
  ];

  const process = [
    {
      step: '01',
      title: 'Site Analysis',
      description: 'Comprehensive assessment of existing infrastructure and requirements.',
      icon: 'fas fa-search'
    },
    {
      step: '02',
      title: 'Design Development',
      description: 'Creating detailed MEP designs with load calculations and specifications.',
      icon: 'fas fa-drafting-compass'
    },
    {
      step: '03',
      title: 'Documentation',
      description: 'Preparing comprehensive technical drawings and documentation.',
      icon: 'fas fa-file-alt'
    },
    {
      step: '04',
      title: 'Implementation Support',
      description: 'Providing technical support during installation and commissioning.',
      icon: 'fas fa-tools'
    }
  ];

  const gallery = [
    'https://images.unsplash.com/photo-1503387762-592deb58ef4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    'https://images.unsplash.com/photo-1581092160562-40aa08e78837?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    'https://images.unsplash.com/photo-1504307651254-35680f356dfd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    'https://images.unsplash.com/photo-1611224923853-80b023f02d71?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  ];

  return (
    <div className="service-page">
      {/* Hero Section */}
      <section className="service-hero parallax-bg">
        <div className="hero-background">
          <img src="https://images.unsplash.com/photo-1503387762-592deb58ef4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80" alt="MEP Services" />
        </div>
        <div className="parallax-overlay"></div>
        <div className="container-wide">
          <div className="container">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
              className="hero-content"
            >
              <div className="breadcrumb">
                <Link to="/">Home</Link>
                <span>/</span>
                <Link to="/services">Services</Link>
                <span>/</span>
                <span>MEP Services</span>
              </div>
              <h1>MEP Executive Drawings</h1>
              <h2>Mechanical, Electrical & Plumbing Solutions</h2>
              <p>Comprehensive MEP design and documentation services ensuring compliance with all industry standards and optimal system performance.</p>
              <div className="hero-buttons">
                <Link to="/contact" className="btn btn-primary">
                  Get Quote <i className="fas fa-arrow-right"></i>
                </Link>
                <a href="tel:+1234567890" className="btn btn-secondary">
                  Call Now <i className="fas fa-phone"></i>
                </a>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Service Overview */}
      <section className="service-overview section">
        <div className="container-wide">
          <div className="container">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="section-title">MEP Engineering Excellence</h2>
              <p className="section-subtitle">
                Professional MEP services that ensure efficient, safe, and compliant building systems
              </p>
            </motion.div>

            <div className="overview-content">
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
                className="overview-text"
              >
                <h3>Expert MEP Design Services</h3>
                <p>
                  Our MEP engineering team brings decades of experience in designing mechanical, electrical, 
                  and plumbing systems for commercial, industrial, and residential projects. We understand 
                  the critical importance of these systems in building functionality and occupant comfort.
                </p>
                <p>
                  From initial concept through detailed design and construction support, we provide 
                  comprehensive MEP services that ensure your building systems operate efficiently, 
                  safely, and in compliance with all applicable codes and standards.
                </p>
                <div className="key-benefits">
                  <div className="benefit-item">
                    <i className="fas fa-check-circle"></i>
                    <span>Energy Efficient Design</span>
                  </div>
                  <div className="benefit-item">
                    <i className="fas fa-check-circle"></i>
                    <span>Code Compliance</span>
                  </div>
                  <div className="benefit-item">
                    <i className="fas fa-check-circle"></i>
                    <span>Cost Optimization</span>
                  </div>
                  <div className="benefit-item">
                    <i className="fas fa-check-circle"></i>
                    <span>Sustainable Solutions</span>
                  </div>
                </div>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
                className="overview-image"
              >
                <img src="https://images.unsplash.com/photo-1503387762-592deb58ef4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="MEP Services Overview" />
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Systems Section */}
      <section className="service-features section parallax-bg">
        <div className="hero-background">
          <img src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80" alt="Systems Background" />
        </div>
        <div className="parallax-overlay"></div>
        <div className="container-wide">
          <div className="container">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="section-title">MEP Systems</h2>
              <p className="section-subtitle">
                Comprehensive design services for all building systems
              </p>
            </motion.div>

            <div className="systems-grid">
              {systems.map((system, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: index * 0.2 }}
                  viewport={{ once: true }}
                  className="system-card card-hover-lift card-glow"
                  whileHover={{ y: -15 }}
                >
                  <div className="system-image">
                    <img src={system.image} alt={system.title} />
                    <div className="system-overlay">
                      <i className={system.icon}></i>
                    </div>
                  </div>
                  <div className="system-content">
                    <h3>{system.title}</h3>
                    <p>{system.description}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="service-overview section">
        <div className="container-wide">
          <div className="container">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="section-title">Service Features</h2>
              <p className="section-subtitle">
                Comprehensive MEP services that cover every aspect of building systems
              </p>
            </motion.div>

            <div className="features-grid">
              {features.map((feature, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="feature-card-alt card-hover-lift"
                  whileHover={{ y: -10 }}
                >
                  <div className="feature-icon">
                    <i className={feature.icon}></i>
                  </div>
                  <div className="feature-image-alt">
                    <img src={feature.image} alt={feature.title} />
                  </div>
                  <div className="feature-content-alt">
                    <h3>{feature.title}</h3>
                    <p>{feature.description}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="service-process section">
        <div className="container-wide">
          <div className="container">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="section-title">Our Process</h2>
              <p className="section-subtitle">
                A systematic approach to MEP design and implementation
              </p>
            </motion.div>

            <div className="process-timeline">
              {process.map((step, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8, delay: index * 0.2 }}
                  viewport={{ once: true }}
                  className="process-step"
                >
                  <div className="step-number">{step.step}</div>
                  <div className="step-icon">
                    <i className={step.icon}></i>
                  </div>
                  <div className="step-content">
                    <h3>{step.title}</h3>
                    <p>{step.description}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="service-gallery section parallax-bg">
        <div className="hero-background">
          <img src="https://images.unsplash.com/photo-1581092160562-40aa08e78837?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80" alt="Gallery Background" />
        </div>
        <div className="parallax-overlay"></div>
        <div className="container-wide">
          <div className="container">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="section-title">Project Gallery</h2>
              <p className="section-subtitle">
                Showcasing our MEP engineering expertise across various projects
              </p>
            </motion.div>

            <div className="gallery-grid">
              {gallery.map((image, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.8, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="gallery-item"
                  whileHover={{ scale: 1.05 }}
                >
                  <img src={image} alt={`Project ${index + 1}`} />
                  <div className="gallery-overlay">
                    <i className="fas fa-search-plus"></i>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="service-cta section">
        <div className="container-wide">
          <div className="container">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="cta-content"
            >
              <h2>Need MEP Design Services?</h2>
              <p>Let our engineering experts design efficient and compliant building systems for your project</p>
              <div className="cta-buttons">
                <Link to="/contact" className="btn btn-primary">
                  Start Your Project
                </Link>
                <Link to="/services" className="btn btn-secondary">
                  View All Services
                </Link>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MEPServices;